'use strict';

/**
 * Виджет выбора месяца, используется в разных местах
 * Выглядит как поле ввода, рядом кнопка.
 */
(function ($) {
    $.widget('fotobook.monthpicker', {
        layoutBlock: null,
        monthpicker: null,

        options: {
            ShowOn: 'both',
            SelectedMonth: 0,
            Button: '<div class="month-selection-icon sprite-image"></div>',
            MonthFormat: 'yy-mm',
        },

        _create() {
            let calendarDate = $('.calendar-container').attr('data-calendar_date');
            if (!calendarDate) {
                calendarDate = new Date().getFullYear() + 1 + '-1';
            }
            if (typeof this.options.i18n === 'undefined' || typeof this.options.i18n.months === 'undefined') {
                this.options.i18n = {};
                this.options.i18n.months = $.datepicker._defaults.monthNames;
            }
            this.options.SelectedMonth = $.datepicker.formatDate('yy-mm', new Date(Date.parse(calendarDate)));
        },
    });
})(jQuery);
